// (KARTEに送信する)講座受講ステータス
export const COURSE_STATUS = {
  COMPLETED: '受講完了',
  IN_PROGRESS: '受講中',
  NOT_STARTED: '未受講',
};

// (KARTEに送信する)講座種別
export const COURSE_TYPE = {
  AREA: '産地講座',
  BASIC: '基礎講座',
};

// クイズの正しい回答番号
export const CORRECT_NUMBERS = [1, 2, 3, 4];

// クイズを閲覧しているクライアントの種別
export const DEVICE_TYPE_FROM_QUIZ = {
  WEB: 'web',
  APP: 'app',
};

// spアプリの場合、カレッジの各タブ上で画面遷移させるためのパス
export const SP_APP_BASIC_PATH = 'enoteca-app-webview://wine-college-basic';
export const SP_APP_AREA_PATH = 'enoteca-app-webview://wine-college-area';
export const SP_APP_QUIZ_PATH = 'enoteca-app-webview://wine-college-quiz';

// spアプリの場合、webviewでモーダルを表示させるためのためのパス
export const SP_APP_MODAL_PATH = 'enoteca-app-webview://winecollege_modal';
